<template>
  <section class="header">
    <NavBar :models="mainNav" />
    <div class="container">
      <cnc-breadcrumbs />
    </div>
  </section>
</template>
<script>
import NavBar from "../components/NavBar";

export default {
  name: "Appheader",
  components: {
    NavBar
  },
  computed: {
    mainNav() {
      return [
                {
          id: 1,
          parentId: null,
          label: "Home",
          route: {
            name: "Home",
            params: {
              accountId: undefined,
              search_date: undefined
            }
          },
          order: 1
        },
        {
          id: 2,
          parentId: null,
          label: "Billing Report",
          route: {
            name: "Billing-report",
            params: {
              accountId: undefined,
              search_date: undefined
            }
          },
          order: 1,
          scope: { or: ["manager", "admin"] }
        },
        {
          id: 3,
          parentId: null,
          label: "Call History",
          route: {
            name: "Call-history"
          },
          order: 1,
          scope: { or: ["manager", "admin"] }
        }
      ];
    }
  },
  async mounted() {
    document.querySelector("body").className += " has-navbar-fixed-top";
  },
  beforeDestroy() {
    const body = document.querySelector("body");
    body.className = body.className
      .split(" ")
      .filter(c => c !== "has-navbar-fixed-top")
      .join(" ");
  }
};
</script>
<style scoped>
.header {
  margin-bottom: 20px;
}
</style>
